import CategoryFilterPresenter from "../components/category-filter/wrapper/presenter/wrapper.js";

const listingFiltersWrapperElement = document.querySelector(`.category-wrapper`);
const headingWrapperElement = document.querySelector(`.heading-category-wrapper`);
const breadcrumbsElement = document.querySelector(`.breadcrumbs`);

if (listingFiltersWrapperElement) {
  const categoryFilterComponent = new CategoryFilterPresenter(
      listingFiltersWrapperElement,
      headingWrapperElement,
      breadcrumbsElement
  );

  categoryFilterComponent.init();
}
